import * as api from "../../api";
import { buildAlertWithLocalizedMessages } from "..";
import { jsError } from "../../common/utils";
/* export * from "./authentication"; */

export const getPersonDiscussions = (personId) => {
  return dispatch => {
    dispatch({ type: "GET_PERSON_DISCUSSIONS_LOADING" });
    api
      .discussionsGetPerson(personId)
      .then(resp => {
        dispatch(operationSucceeded(resp.data));
        dispatch({ type: "GET_PERSON_DISCUSSIONS_LOADING_DONE" });
      })
      .catch(e => {
        jsError(e);
        dispatch({ type: "GET_PERSON_DISCUSSIONS_LOADING_DONE" });
        dispatch(operationFail());
        dispatch(buildAlertWithLocalizedMessages(
          "ERROR",
          "GetPersonDiscussionsErrorAlertTitle",
          "Virhe henkilön keskusteluiden haussa",
          e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
      });
  };
};

const operationSucceeded = data => ({
  type: "GET_PERSON_DISCUSSIONS_SUCCEEDED",
  payload: { discussions: data.length > 0 ? data : [] },
});

const operationFail = () => ({
  type: "GET_PERSON_DISCUSSIONS_FAIL"
});
